<template>
  <!-- 页脚 -->
  <footer class="footer flex-content" aria-label="网站页脚">
    <div v-if="props.isAi"
         class="divider-box"
         aria-hidden="true"></div>
    <div v-if="!props.isAi"
         class="footer-content">
      <div class="footer-center">
        <h2 class="footer-title">Contact us</h2>
        <p class="footer-tel">tel：18652956287</p>
        <p class="footer-address">{{ $t('home.Footer.address') }}</p>
        <button class="footer-contact"
                @click="goCustomer"
                @mouseover="focusContact(true)"
                @mouseout="focusContact(false)"
                aria-label="在线客服">
          <img :src="footer_chat"
               :class="isFocus ? 'footer-icon-hover' : 'footer-icon'"
               alt="客服图标" />
          <span :class="isFocus ? 'footer-contact-title-hover' : 'footer-contact-title'">{{ $t('home.Footer.chatOnline') }}
          </span>
          <img :class="isFocus ? 'footer-arrow-hover' : 'footer-arrow'"
               :src="footer_arrow"
               alt="箭头" />
        </button>
      </div>
      <div class="footer-right">
        <p class="footer-right-title">{{ $t('home.Footer.consultant') }}</p>
        <img :src="service_img"
             class="footer-right-img"
             alt="顾问二维码" />
        <div class="footer-right-box">
          <div v-for="(item, index) in footer_list"
               :key="index"
               class="footer-right-item">
            <img :src="item.img"
                 alt="社交媒体图标" />
            <div class="footer-right-item-before" aria-hidden="true"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div style="display: flex;">
        <div class="footer-box">
          <a target="_blank"
             href="https://beian.miit.gov.cn/ ">
            <p style="color: #999">{{ $t('home.Footer.beian') }}</p>
          </a>
        </div>
        <div class="footer-box">
          <a target="_blank"
             href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011702000260">
            <img src="https://cdn.microsoftstore.com.cn/media/footer/beianbgs_20220830.png"
                 style="float: left"
                 alt="公安备案图标" />
            <p style="color: #999">{{ $t('home.Footer.publicSafety') }}</p>
          </a>
        </div>
      </div>
      <p class="footer-box">{{ copyright ? copyright.value : "" }}</p>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from "vue"
import type { Plugin, SysConfigService } from "@/plugins"
import { PLUGIN_SYS_CONFIG } from "@/plugins/builtin/BuiltinPluginSymbol"
import { container } from "tsyringe"
import footer_chat from "../../assets/home_image/chat.png"
import footer_arrow from "../../assets/home_image/ic-arrow.png"
import service_img from "../../assets/home_image/service_img.png"
import wx from "../../assets/home_image/wx.png"
import gongzhonghao from "../../assets/home_image/gongzhonghao.png"
import xiaohongshu from "../../assets/home_image/xiaohongshu.png"
import douyin from "../../assets/home_image/douyin.png"
import weibo from "../../assets/home_image/weibo.png"
import { useChatWoot } from "@huntersofbook/chatwoot-vue"
const { toggle, setLabel } = useChatWoot()
const plugin = container.resolve<Plugin<unknown, SysConfigService>>(PLUGIN_SYS_CONFIG)
const copyright = plugin.service.value("copyright")
const props = defineProps<{
  isAi?: boolean
}>()
const isFocus = ref<boolean>(false)
const focusContact = (flag: boolean) => {
  isFocus.value = flag
}
const footer_list = [
  {
    img: wx
  },
  {
    img: gongzhonghao
  },
  {
    img: xiaohongshu
  },
  {
    img: douyin
  },
  {
    img: weibo
  },
]
const goCustomer = () => {
  toggle("open")
  setLabel("name")
}

</script>

<style scoped
       lang="less">

       .footer {
         .divider-box {
           height: 1px;
           background-color: #f6f6f6;
           opacity: .1;
           width: 100%;
         }

         .footer-content {
           height: 100%;
           width: 100%;
           background-color: #111;
           color: #fff;
           display: flex;
           align-items: center;
           justify-content: space-between;
           padding: 80px 260px;

           .footer-center {
             .footer-title {
               font-weight: bold;
               font-size: 40px;
               color: #FFFFFF;
             }

             .footer-tel {
               font-weight: bold;
               font-size: 20px;
               color: #FFFFFF;
               margin: 60px 0 30px 0;
               text-transform: uppercase;
             }

             .footer-address {
               font-size: 14px;
               color: rgba(255, 255, 255, 0.6);
             }

             .footer-contact {
               display: flex;
               margin-top: 50px;
               align-items: center;
               cursor: pointer;

               .footer-icon {
                 width: 20px;
                 height: 20px;
                 opacity: 0.6;
               }

               .footer-icon-hover {
                 width: 20px;
                 height: 20px;
               }

               .footer-contact-title {
                 font-size: 14px;
                 color: rgba(255, 255, 255, 0.6);
                 margin: 0 15px;
               }

               .footer-contact-title-hover {
                 font-size: 14px;
                 margin: 0 15px;
                 color: rgba(255, 255, 255);
               }

               .footer-arrow {
                 width: 16px;
                 height: 7px;
                 opacity: 0.6;
               }

               .footer-arrow-hover {
                 width: 16px;
                 height: 7px;
               }
             }

           }

           .footer-right {
             .footer-right-title {
               font-size: 14px;
               color: rgba(255, 255, 255, 0.6);
             }

             .footer-right-img {
               width: 152px;
               height: 152px;
               margin-top: 10px;
               margin-bottom: 20px;
             }

             .footer-right-box {
               display: flex;

               .footer-right-item {
                 width: 28px;
                 height: 28px;
                 border-radius: 4px;
                 margin-right: 15px;
                 position: relative;

                 img {
                   width: 28px;
                   height: 28px;
                 }

                 .footer-right-item-before {
                   position: absolute;
                   top: 0;
                   left: 0;
                   width: 28px;
                   height: 28px;
                   background: rgba(17, 17, 17, 0.6);
                   cursor: pointer;
                 }

                 .footer-right-item-before:hover {
                   position: absolute;
                   top: 0;
                   left: 0;
                   width: 28px;
                   height: 28px;
                   background: rgba(255, 255, 255, 0);
                 }

               }

               .footer-right-item:last-child {
                 margin-right: 0;
               }
             }
           }
         }

         .footer-bottom {
           height: 40px;
           width: 100%;
           line-height: 40px;
           background-color: #111;
           padding: 0 260px;
           display: flex;
           justify-content: space-between;

           .footer-box {
             display: inline-block;
             height: 40px;
             color: #999999;

             a {
               display: flex;
               align-items: center;
               height: 100%;

               img {
                 width: 20px;
                 height: 20px;
                 margin: 0 5px;
               }

               p {
                 margin: 0;
                 color: #999999;
               }
             }
           }
         }

         .flex {
           display: flex;
           justify-content: center;
           align-items: center;
         }
       }
</style>
